import {
  DrugMgPerUnit,
  DrugUnit,
  NumberOfUnitsState,
  DrugAmountState,
  DrugStrengthState,
  PatientWeightState,
  CalculatedValues,
  DefaultWithDrugMgPerUnit,
  DefaultWithDrugUnit,
} from '../../../types/DrugDosageCalculator.type';
import { notNullIsNumberValidator } from './calculatorUtils';

export const getWeightInitialState = (value: string): PatientWeightState => {
  return {
    value,
    error: false,
    validator: notNullIsNumberValidator,
  };
};

export const numberOfUnitsInitialState = (
  initialValues: CalculatedValues<DrugMgPerUnit> = DefaultWithDrugMgPerUnit
): NumberOfUnitsState => {
  const {
    strength = '',
    dose = '',
    unit = DrugMgPerUnit['mg/ml'],
    result = '',
  } = initialValues;
  return {
    strength: {
      value: strength,
      error: false,
      validator: notNullIsNumberValidator,
    },
    mgPerUnit: { value: unit, error: false },
    dose: { value: dose, error: false, validator: notNullIsNumberValidator },
    result,
  };
};

export const drugAmountInitialState = (
  initialValues: CalculatedValues<DrugMgPerUnit> = DefaultWithDrugMgPerUnit
): DrugAmountState => {
  const {
    strength = '',
    dose = '',
    unit = DrugMgPerUnit['mg/ml'],
    result = '',
  } = initialValues;
  return {
    strength: {
      value: strength,
      error: false,
      validator: notNullIsNumberValidator,
    },
    mgPerUnit: { value: unit, error: false },
    numberOfUnits: {
      value: dose,
      error: false,
      validator: notNullIsNumberValidator,
    },
    result,
  };
};

export const drugStrengthInitialState = (
  initialValues: CalculatedValues<DrugUnit> = DefaultWithDrugUnit
): DrugStrengthState => {
  const {
    strength = '',
    dose = '',
    unit = DrugUnit['ml'],
    result = '',
  } = initialValues;
  return {
    numberOfUnits: {
      value: strength,
      error: false,
      validator: notNullIsNumberValidator,
    },
    unit: { value: unit, error: false },
    dose: { value: dose, error: false, validator: notNullIsNumberValidator },
    result,
  };
};
